import { useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  ProgressBar,
  Row,
} from "react-bootstrap";
import { LinearProgress } from "@material-ui/core";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  GET_PROJECT_PLANNER,
  GET_TASK_PLANNER,
} from "../../../graphql/queries";

import { CREATE_TASK_PLANNER } from "../../../graphql/mutation";
import { AiOutlinePlus } from "react-icons/ai";
import { connect } from "react-redux";
import { useFormik } from "formik";
import {
  matchProjectID,
  getDateValidationWorker,
} from "../../../redux/actions/plannerAction";
import SEO from "../../SEO";

const ProjectDetail = ({
  createNewTask,
  matchProjectID,
  projectID,
  getDateValidationWorker,
  dateValidationWorker,
}) => {
  let workerList = [];

  const convertToDate = (inputDate) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    let date = new Date(+inputDate);
    return date.toLocaleDateString("id-ID", options);
  };

  const history = useHistory();
  const match = useRouteMatch();

  console.log(match.params.id);

  useEffect(() => {
    matchProjectID(match.params.id);
    console.log();
  }, []);

  const formik = useFormik({
    initialValues: createNewTask,
    onSubmit: (values) => {
      console.log(values);
      createTask({
        variables: {
          ...values,
          project_id: parseInt(projectID),
        },
      });
    },
  });

  const { error: taskError, data: taskData, loading: taskLoading } = useQuery(
    GET_TASK_PLANNER,
    {
      pollInterval: 1000,
    }
  );

  const {
    error: projectError,
    data: projectData,
    loading: projectLoading,
  } = useQuery(GET_PROJECT_PLANNER);

  const [createTask] = useMutation(CREATE_TASK_PLANNER);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (taskLoading) return <LinearProgress />;
  if (taskError) return "Error...";

  const filterTaskData = taskData.findAllTaskPlanner.filter(
    (item) => item.project_id == match.params.id
  );

  if (projectLoading) return <LinearProgress />;
  if (projectError) return "Error...";

  const filterProjectData = projectData.findAllProjectPlanner.filter(
    (item) => item.id == match.params.id
  );

  filterProjectData[0].worker.map(({ fullname }) => {
    return workerList.push(fullname);
  });

  // projectData.findAllProjectPlanner.map(({id, start_date, worker}) => {
  //   return getDateValidationWorker(id, start_date, worker)
  // })

  // console.log(dateValidationWorker)

  const getTaskDetail = filterTaskData
    .slice()
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map(({ id, task, is_check }, key) => {
      return (
        <div className="tasklist-progress my-3" key={key}>
          <p className="text-capitalize m-0">
            {key + 1}. {is_check == "true" ? <del>{task}</del> : task}
          </p>
        </div>
      );
    });

  // const getProgressData = filterTaskData.length;

  // console.log(getProgressData);

  // const getProjectId = projectData.findAllProjectPlanner
  //   .slice()
  //   .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
  //   .map(({ id }, key) => {
  //     console.log(id)
  //     return (
  //       <>
  //         <option value={id} key={key}>
  //           {id}
  //         </option>
  //       </>
  //     );
  //   });j

  const getNotes = filterProjectData[0].notes.map(({ note }, key) => {
    console.log(note);
    return (
      <>
        <li className="list-group-item" key={key}>
          - {note}
        </li>
      </>
    );
  });

  const isChecked = filterTaskData.filter(({ is_check }) => is_check == "true")
    .length;

  const now = Math.floor((isChecked / filterTaskData.length) * 100);

            const progressInstance = (
              <ProgressBar
                animated
                now={now || 0}
                min={0}
                variant={now == 100 ? "success" : "primary"}
                label={`${now}%`}
              />
            );

  console.log(filterProjectData[0]);

  return (
    <div className="project-list-section m-2 pb-5">
      <SEO title="Planner" description="Project List Detail" content="Project List Detail"  />

      <Button
        variant="primary"
        onClick={() => history.push("/dashboard/planner/")}
      >
        Back
      </Button>
      <h1 className="text-center text-primary my-5">Detail Task</h1>
      <Row>
        <Col lg={10} md={10} sm={10} xs={10} className="mx-auto tasklist-progress">
          <Row className="text-center d-flex justify-content-center align-items-center">
          <Col lg={3} md={6} sm={6}>
              <div className="mt-2">
                <span className="font-weight-bold">Start Date</span>
                <br />
                <span className="font-weight-normal">
                  {convertToDate(filterProjectData[0].start_date)}
                </span>
              </div>
            </Col>
            <Col lg={3} md={6} sm={6}>
              <div className="mt-2">
                <span className="font-weight-bold">Due Date</span>
                <br />
                <span className="font-weight-normal">
                  {convertToDate(filterProjectData[0].due_date)}{" "}
                </span>
              </div>
            </Col>
            <Col lg={3} md={6} sm={6}>
              <div className="mt-2">
                <span className="font-weight-bold">Planner Name</span>
                <br />
                <span className="text-capitalize">{filterProjectData[0].created_by.fullname}</span>
              </div>
            </Col>
            <Col lg={3} md={6} sm={6}>
              <div className="mt-2">
                <span className="font-weight-bold">Worker Name</span>
                <br />
                <span className="text-capitalize">{workerList.join(", ")}</span>
              </div>
            </Col>
          </Row>
          <div className="my-3">
            <h3 className="font-weight-bold text-center my-5">
              {filterProjectData[0].title}
            </h3>
          </div>
          <div className="my-3">
            <p className="font-weight-bold">
              Project ID:{" "}
              <span className="font-weight-normal">{match.params.id}</span>
            </p>
          </div>
          <div className="my-3">
            <p className="font-weight-bold">Project Description</p>
            {filterProjectData[0].description}
          </div>
          <div>
            <h5 className="font-weight-bold my-3">Task Progress:</h5>
            {progressInstance}

            <h5 className="font-weight-bold my-3">
              Task List:{" "}
              <span
                className={`font-weight-normal ${
                  getTaskDetail ? "d-none" : ""
                }`}
              >
                None
              </span>
            </h5>
            {getTaskDetail}
          </div>
          {filterProjectData[0].status === "approve" ? (
            ""
          ) : (
            <form onSubmit={formik.handleSubmit}>
              <Form.Group>
                <InputGroup className="mb-3">
                  <InputGroup.Append>
                    <Form.Control
                      type="text"
                      placeholder={projectID}
                      name="project_id"
                      value={formik.values.project_id}
                      onChange={formik.handleChange}
                      style={{ width: "50px" }}
                      className="text-center"
                      hidden
                      disabled
                    ></Form.Control>
                  </InputGroup.Append>
                  <Form.Control
                    placeholder="Add a new task"
                    aria-label="Add a new task"
                    aria-describedby="basic-addon2"
                    name="task"
                    value={formik.values.task}
                    onChange={formik.handleChange}
                  />
                  <InputGroup.Append>
                    <Button variant="primary" type="submit">
                      <AiOutlinePlus style={{ color: "white" }} />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </Form.Group>
            </form>
          )}
          <ul className="list-group">
            <span>
              <strong>Notes: </strong>
              {!filterProjectData[0].notes[0] ? "None" : ""}
            </span>
            {filterProjectData[0].notes[0] ? getNotes : ""}
          </ul>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    createNewTask: state.planner.createNewTask,
    projectID: state.planner.matchProjectID,
    dateValidationWorker: state.planner.dateValidationWorker,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    matchProjectID: (projectID) => dispatch(matchProjectID(projectID)),
    getDateValidationWorker: (dateValidationWorker) =>
      dispatch(getDateValidationWorker(dateValidationWorker)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetail);
